import { Trash } from "@phosphor-icons/react";

import type { ReportedProduct } from "./retailerReportIssueData";

type ReportedProductCardProps = {
  product: ReportedProduct;
  showDelete?: boolean;
  onDelete?: () => void;
};

export const ReportedProductCard = ({
  product,
  showDelete = false,
  onDelete,
}: ReportedProductCardProps) => (
  <div className="border-fs-border-muted bg-fs-surface-primary flex gap-(--slate-spacing-element-medium) rounded-[4px] border p-(--slate-spacing-element-large)">
    <div className="bg-fs-surface-tertiary size-[72px] shrink-0 overflow-hidden rounded-[2px]">
      <img src={product.imageUrl} alt="" className="size-full object-cover" />
    </div>
    <div className="flex min-w-0 flex-1 flex-col gap-[2px]">
      <div className="flex items-start justify-between gap-(--slate-dimensions-2)">
        <span className="type-fs-paragraph-medium text-fs-message-text-critical">
          {product.issueLabel}
        </span>
        {showDelete ? (
          <button
            type="button"
            aria-label={`Remove ${product.name}`}
            className="text-fs-text-primary flex size-4 shrink-0 items-center justify-center"
            onClick={onDelete}
          >
            <Trash size={16} weight="regular" />
          </button>
        ) : null}
      </div>
      <span className="type-fs-paragraph-medium text-fs-text-primary">
        {product.name}
      </span>
      <span className="type-fs-paragraph text-fs-text-primary">
        {product.variant}
      </span>
    </div>
  </div>
);
